// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Custom scrollbar for WebKit browsers (Chrome, Edge, Safari) */
::-webkit-scrollbar {
width: 16px;
}

::-webkit-scrollbar-track {
background: #e0e0e0;
}

::-webkit-scrollbar-thumb {
background-color: #0051a1; /* Matches your app's theme */
border-radius: 8px;
border: 3px solid #e0e0e0;
}

::-webkit-scrollbar-thumb:hover {
background-color: #003f7f;
}

/* Firefox scrollbar styling */
body {
scrollbar-width: auto;
scrollbar-color: #0051a1 #e0e0e0;
}

/* Command Palette Styles */
#command-palette-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 15vh;
  z-index: 1000;
}

#command-palette-overlay.hidden {
  display: none;
}

#command-palette {
  width: 100%;
  max-width: 600px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

#command-input {
  width: 100%;
  padding: 16px;
  font-size: 1.1em;
  border: none;
  border-bottom: 1px solid #eee;
  outline: none;
}

#command-list {
  list-style: none;
  margin: 0;
  padding: 8px;
  max-height: 300px;
  overflow-y: auto;
}

#command-list li {
  padding: 12px 16px;
  cursor: pointer;
  border-radius: 4px;
}

#command-list li:hover, #command-list li.selected {
  background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,gEAAgE;AAChE;AACA,WAAW;AACX;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,yBAAyB,EAAE,6BAA6B;AACxD,kBAAkB;AAClB,yBAAyB;AACzB;;AAEA;AACA,yBAAyB;AACzB;;AAEA,8BAA8B;AAC9B;AACA,qBAAqB;AACrB,gCAAgC;AAChC;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n/* Custom scrollbar for WebKit browsers (Chrome, Edge, Safari) */\r\n::-webkit-scrollbar {\r\nwidth: 16px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\nbackground: #e0e0e0;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\nbackground-color: #0051a1; /* Matches your app's theme */\r\nborder-radius: 8px;\r\nborder: 3px solid #e0e0e0;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\nbackground-color: #003f7f;\r\n}\r\n\r\n/* Firefox scrollbar styling */\r\nbody {\r\nscrollbar-width: auto;\r\nscrollbar-color: #0051a1 #e0e0e0;\r\n}\r\n\r\n/* Command Palette Styles */\r\n#command-palette-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  padding-top: 15vh;\r\n  z-index: 1000;\r\n}\r\n\r\n#command-palette-overlay.hidden {\r\n  display: none;\r\n}\r\n\r\n#command-palette {\r\n  width: 100%;\r\n  max-width: 600px;\r\n  background-color: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\r\n  overflow: hidden;\r\n}\r\n\r\n#command-input {\r\n  width: 100%;\r\n  padding: 16px;\r\n  font-size: 1.1em;\r\n  border: none;\r\n  border-bottom: 1px solid #eee;\r\n  outline: none;\r\n}\r\n\r\n#command-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 8px;\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n\r\n#command-list li {\r\n  padding: 12px 16px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n}\r\n\r\n#command-list li:hover, #command-list li.selected {\r\n  background-color: #f0f0f0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
